<template>
    <div>
        <div ref="cursorDot" class="cursor-dot"></div>
        <div ref="cursorOutline" class="cursor-outline"></div>
    </div>
</template>

<script>
export default {
    name: 'CustomCursor',
    data() {
        return {
            cursorX: 0,
            cursorY: 0,
            outlineX: 0,
            outlineY: 0,
            isHovering: false,
            isMobile: false
        }
    },
    mounted() {
        // Check if device is mobile
        this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
        
        // Don't initialize custom cursor on mobile devices
        if (this.isMobile) {
            return
        }
        
        // Add event listeners
        document.addEventListener('mousemove', this.handleMouseMove)
        document.addEventListener('mouseenter', this.handleMouseEnter)
        document.addEventListener('mouseleave', this.handleMouseLeave)
        
        // Add hover effects for interactive elements
        this.addHoverEffects()
        
        // Start animation loop
        this.animate()
    },
    beforeUnmount() {
        if (this.isMobile) return
        
        document.removeEventListener('mousemove', this.handleMouseMove)
        document.removeEventListener('mouseenter', this.handleMouseEnter)
        document.removeEventListener('mouseleave', this.handleMouseLeave)
    },
    methods: {
        handleMouseMove(e) {
            this.cursorX = e.clientX
            this.cursorY = e.clientY
        },
        
        handleMouseEnter() {
            if (this.$refs.cursorDot) {
                this.$refs.cursorDot.style.opacity = '1'
            }
            if (this.$refs.cursorOutline) {
                this.$refs.cursorOutline.style.opacity = '1'
            }
        },
        
        handleMouseLeave() {
            if (this.$refs.cursorDot) {
                this.$refs.cursorDot.style.opacity = '0'
            }
            if (this.$refs.cursorOutline) {
                this.$refs.cursorOutline.style.opacity = '0'
            }
        },
        
        addHoverEffects() {
            const hoverTargets = document.querySelectorAll('a, button, .btn, [role="button"]')
            
            hoverTargets.forEach(target => {
                target.addEventListener('mouseenter', () => {
                    this.isHovering = true
                    if (this.$refs.cursorOutline) {
                        this.$refs.cursorOutline.style.transform = 'translate(-50%, -50%) scale(1.5)'
                    }
                })
                
                target.addEventListener('mouseleave', () => {
                    this.isHovering = false
                    if (this.$refs.cursorOutline) {
                        this.$refs.cursorOutline.style.transform = 'translate(-50%, -50%) scale(1)'
                    }
                })
            })
        },
        
        animate() {
            // Smooth follow effect for outline
            this.outlineX += (this.cursorX - this.outlineX) * 0.15
            this.outlineY += (this.cursorY - this.outlineY) * 0.15
            
            // Update dot position (instant)
            if (this.$refs.cursorDot) {
                this.$refs.cursorDot.style.left = `${this.cursorX}px`
                this.$refs.cursorDot.style.top = `${this.cursorY}px`
            }
            
            // Update outline position (smooth)
            if (this.$refs.cursorOutline) {
                this.$refs.cursorOutline.style.left = `${this.outlineX}px`
                this.$refs.cursorOutline.style.top = `${this.outlineY}px`
            }
            
            requestAnimationFrame(this.animate)
        }
    }
}
</script>

<style scoped>
.cursor-dot,
.cursor-outline {
    position: fixed;
    pointer-events: none;
    z-index: 10000;
    opacity: 0;
    transition: opacity 0.3s ease;
}

.cursor-dot {
    width: 8px;
    height: 8px;
    background: #6698C8;
    border-radius: 50%;
    transform: translate(-50%, -50%);
}

.cursor-outline {
    width: 30px;
    height: 30px;
    border: 2px solid rgba(102, 152, 200, 0.5);
    border-radius: 50%;
    transform: translate(-50%, -50%);
    transition: transform 0.15s ease, opacity 0.3s ease;
}

@media (max-width: 1024px) {
    .cursor-dot,
    .cursor-outline {
        display: none;
    }
}
</style>

